import { Route, Switch } from "react-router-dom";
import {
  PATH_WORK_LOGS_EDIT,
  PATH_WORK_LOGS_PAYEE,
  PATH_WORK_LOGS_PAYEE_DETAILS,
  PATH_WORK_LOGS_PAYEE_TAB_IN_PROGRESS,
  PATH_WORK_LOGS_PAYEE_TAB_SUBMITTED,
  PATH_WORK_LOGS_PAYER,
  PATH_WORK_LOGS_PAYER_DETAILS
} from "./paths";
import { RouteEdit } from "./routes/RouteEdit";
import { RoutePayeeLogs } from "./routes/RoutePayeeLogs";
import { RoutePayeeWorkLogDetails } from "./routes/RoutePayeeWorkLogDetails";
import { RoutePayerLogs } from "./routes/RoutePayerLogs";
import { RoutePayerWorkLogDetails } from "./routes/RoutePayerWorkLogDetails";

export const WorkLogs = () => {
  return (
    <Switch>
      <Route path={PATH_WORK_LOGS_EDIT} component={RouteEdit} />

      <Route
        path={[
          PATH_WORK_LOGS_PAYEE,
          PATH_WORK_LOGS_PAYEE_TAB_IN_PROGRESS,
          PATH_WORK_LOGS_PAYEE_TAB_SUBMITTED
        ]}
        exact
        component={RoutePayeeLogs}
      />

      <Route path={PATH_WORK_LOGS_PAYER} exact component={RoutePayerLogs} />

      <Route
        path={PATH_WORK_LOGS_PAYEE_DETAILS}
        component={RoutePayeeWorkLogDetails}
      />

      <Route
        path={PATH_WORK_LOGS_PAYER_DETAILS}
        component={RoutePayerWorkLogDetails}
      />
    </Switch>
  );
};
